import React from 'react';
import {isTrustedUrl} from '@utils/validateUrl.utils';

interface ImageViewerProps {
  url?: string;
  className?: string;
  alt?: string;
  key?: any;
  validUrlExtension?: string;
  invalidUrlExtension?: string;
  onClick?: (e: any) => void;
  onError?: (e: any) => void;
  height?: string | number;
  width?: string | number;
}

export const Image = React.memo(({url = '', ...props}: ImageViewerProps) => {
  const {trusted, url: imageUrl} = isTrustedUrl(url);

  if (trusted) return <img {...props} src={imageUrl} />;
  else return <></>;
});
